export const PERSIST_NAVAT_CRM = 'NavatCRM'
